import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login.vue'
import footers from '@/components/footers.vue'
import zhuce from '@/components/zhuce.vue'
import jigou from '@/components/jigou.vue'
import securitycode from '@/components/securitycode.vue'
import phone_find from '@/components/phonefind.vue'
import email_find from '@/components/email.vue'
import resetpassword from '@/components/resetpassword.vue'
import firstphone from '@/components/firstphone.vue'
import loginsucceed from '@/components/loginsucceed.vue'
import upgradedusers from '@/components/upgradedusers.vue'
import backstage from '@/components/backstage_succeed.vue'
import schoolJoin from '@/components/school_join.vue'
import newupgrade from '@/components/new_upgrade.vue'
import schoolgoin from '@/components/school_login.vue'
import Net_Work from "../apis/network.js";
import school_code from '@/components/school_code.vue'
import solution from '@/components/solution.vue'
import solutionApply from '@/components/solution-apply.vue'

import axios from "axios";
import Qs from "qs";
import {
  change_token, try_get_token
} from "../apis/token.js";
axios.defaults.baseURL = Net_Work.publicApi;
axios.defaults.headers.post["Content-Type"] = Net_Work.publicPostset;
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
const router = new Router({
  routes: [{
      path: '/',
      redirect: '/password-login'
    }, {
      path: '/password-login',
      name: 'login',
      component: login
    }, {
      path: '/regist',
      name: 'zhuce',
      component: zhuce
    }, {
      path: '/msgcode-login',
      name: 'yanzhengmacode',
      component: securitycode
    }, {
      path: '/reset-password-by-phone',
      name: 'phone-find',
      component: phone_find
    }, {
      path: '/reset-password-by-email',
      name: 'email',
      component: email_find
    }, {
      path: '/reset-password',
      name: 'resetpassworld',
      component: resetpassword
    }, {
      path: '/first-login',
      name: 'firstphone',
      component: firstphone
    }, {
      path: '/active-email',
      name: 'loginsucceed',
      component: loginsucceed
    }, {
      path: '/upgrade-school-account',
      name: 'upgradedusers ',
      component: upgradedusers
    }, {
      path: '/backstage',
      name: 'backstage',
      component: backstage
    },
    {
      path: '/school-regist',
      name: 'jigou',
      component: jigou
    }, {
      path: '/school-join',
      name: 'school_join',
      component: schoolJoin
    }, {
      path: '/school-information',
      name: 'new_upgradedusers',
      component: newupgrade
    },
    {
      path: '/school-login',
      name: 'schoollogin',
      component: schoolgoin
    },
    {
      path: '/school-code-login',
      name: 'school_code',
      component: school_code
    },
    {
      path: '/solution',
      name: 'solution',
      component: solution
    },
    {
      path: '/solution-apply',
      name: 'solutionApply',
      component: solutionApply
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})
router.beforeEach((to, from, next) => {

  if (to.path == '/password-login') {
    // 获取token进行登录
    var accessToken = try_get_token();
    
    if (accessToken) {
      axios
        .post(
          "/s/api/main/check/token",
          Qs.stringify({
            accessToken: accessToken
          })
        )
        .then(res => {
          if (res.data.code === 0) {
            location.replace(Net_Work.publicPhoneAddress);
          } else {
            next();
          }
        }).catch(res => {
          next();
        })
    } else {
      next();
    }
  } else {
    next();
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js